import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React__default from 'react';
import { Link } from 'react-router-dom';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';

function CreateButton(props) {
  const { title, to } = props;
  const isXSScreen = useMediaQuery(
    (theme) => theme.breakpoints.down("xs")
  );
  if (!to) {
    return null;
  }
  return isXSScreen ? /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      component: Link,
      color: "primary",
      title,
      size: "small",
      to
    },
    /* @__PURE__ */ React__default.createElement(AddCircleOutline, null)
  ) : /* @__PURE__ */ React__default.createElement(Button, { component: Link, variant: "contained", color: "primary", to }, title);
}

export { CreateButton };
//# sourceMappingURL=CreateButton.esm.js.map
